import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { AccountMetricView } from '../account-detail.model';

@Component({
  selector: 'bn-account-summary-metrics',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="bn-account-metrics"
      [style.--account-summary-columns]="columns()"
      data-testid="account-metrics"
    >
      @for (metric of metrics(); track metric.label) {
        <div class="bn-account-metrics__item">
          <p class="bn-account-metrics__label">{{ metric.label }}</p>
          <p class="bn-account-metrics__value">{{ metric.value }}</p>
        </div>
      }
    </div>
  `,
  styles: `
    .bn-account-metrics {
      display: grid;
      justify-content: start;
      grid-template-columns: repeat(var(--account-summary-columns, 4), max-content);
      gap: 1.25rem 1.75rem;
    }

    .bn-account-metrics__item {
      min-width: 6.75rem;
    }

    .bn-account-metrics__label {
      margin: 0 0 0.4rem;
      font-size: 0.6875rem;
      font-weight: 600;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: var(--p-text-muted-color);
    }

    .bn-account-metrics__value {
      margin: 0;
      font-size: 1.25rem;
      line-height: 1.25;
      font-weight: 700;
      color: var(--p-primary-900, var(--p-text-color));
    }

    @media (max-width: 40rem) {
      .bn-account-metrics {
        grid-template-columns: repeat(2, max-content);
      }
    }
  `,
})
export class AccountSummaryMetricsComponent {
  readonly metrics = input.required<AccountMetricView[]>();
  readonly columns = input(4);
}
